import PropTypes from "prop-types";
import { useState } from "react";
import {
  Box,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  TablePagination,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  Alert,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import APIAxios from "../../Api/APIAxios";
import SessaoAuth from "../../Hooks/SessaoAuth";

const URL_SERVICE = "/menu";

const MenuTabela = ({ menu, setMenu }) => {
  const { sessao, setSessao } = SessaoAuth();
  const setRowsPerPage = (newRowsPerPage) => {
    setSessao((prev) => ({ ...prev, rowsPerPage: newRowsPerPage }));
  };

  const apiAxios = APIAxios();
  const navigate = useNavigate();

  const [orderBy, setOrderBy] = useState("menu");
  const [order, setOrder] = useState("asc");
  const [page, setPage] = useState(0);
  const [openExcluir, setOpenExcluir] = useState(false);
  const [sucessoAviso, setSucessoAviso] = useState(false);
  const [erroAviso, setErroAviso] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selMenu, setSelMenu] = useState(null);

  // Função para ordenar os dados
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...menu].sort((a, b) => {
    const valA = a[orderBy] ?? "";
    const valB = b[orderBy] ?? "";

    if (valA < valB) return order === "asc" ? -1 : 1;
    if (valA > valB) return order === "asc" ? 1 : -1;
    return 0;
  });

  const paginatedData = sortedData.slice(
    page * (sessao.rowsPerPage || 10),
    page * (sessao.rowsPerPage || 10) + (sessao.rowsPerPage || 10),
  );

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Função para editar menu
  const handleEditar = (e, menu) => {
    e.preventDefault();
    navigate(`/menuboot/alterar/${menu.id}`);
  };

  const handleClickOpenExcluir = (e, menu) => {
    setSelMenu(menu);
    setOpenExcluir(true);
  };

  const handleClickCloseExcluir = () => {
    setOpenExcluir(false);
  };

  const handleCloseAviso = (event, reason) => {
    if (reason === "clickaway") return;
    setErroAviso(false);
    setSucessoAviso(false);
  };

  const excluirMenu = async () => {
    setLoading(true);
    setOpenExcluir(false);
    setErroAviso(false);
    setSucessoAviso(false);

    try {
      const response = await apiAxios.delete(`${URL_SERVICE}/${selMenu.id}`);
      if (response.data.sucesso === "SIM") {
        setMenu((prev) => prev.filter((item) => item.id !== selMenu.id)); // Atualiza a lista de menus removendo a linha excluída
        setSucessoAviso(true);
      } else {
        setErroAviso(true);
      }
    } catch (error) {
      setErroAviso(true);
    }

    setLoading(false);
  };

  useEffect(() => {
    setPage(0);
  }, [menu]);

  function pegarBaseUrl(url) {
  // encontra a posição da terceira '/'
  const posicao = url.indexOf('/', url.indexOf('//') + 2);

  // se não tiver '/', retorna a própria URL
  return posicao === -1 ? url : url.slice(0, posicao);
}

  return (
    <Box>
      {/* Diálogo para Excluir Menu */}
      <Dialog
        open={openExcluir}
        onClose={handleClickCloseExcluir}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Deseja Excluir este item de Menu?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Após a exclusão, o item do menu não poderá ser recuperado.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickCloseExcluir}>Cancelar</Button>
          <Button onClick={excluirMenu} autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Aviso de Exclusão com sucesso */}
      <Snackbar
        open={sucessoAviso}
        autoHideDuration={5000}
        onClose={handleCloseAviso}
        anchorOrigin={{ vertical: "top", horizontal: "center" }} // posição suspensa
      >
        <Alert
          onClose={handleCloseAviso}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Exclusão efetuada com sucesso!
        </Alert>
      </Snackbar>

      {/* Aviso de Erro de Exclusão*/}
      <Snackbar
        open={erroAviso}
        autoHideDuration={5000}
        onClose={handleCloseAviso}
        anchorOrigin={{ vertical: "top", horizontal: "center" }} // posição suspensa
      >
        <Alert
          onClose={handleCloseAviso}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Não foi possível excluir o item de menu.
        </Alert>
      </Snackbar>

      <Paper sx={{ mt: 2 }} elevation={4}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  sortDirection={orderBy === "descricao" ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === "descricao"}
                    direction={orderBy === "descricao" ? order : "asc"}
                    onClick={() => handleSort("descricao")}
                  >
                    Descrição
                  </TableSortLabel>
                </TableCell>

                <TableCell sortDirection={orderBy === "grupo" ? order : false}>
                  <TableSortLabel
                    active={orderBy === "grupo"}
                    direction={orderBy === "grupo" ? order : "asc"}
                    onClick={() => handleSort("grupo")}
                  >
                    Grupo
                  </TableSortLabel>
                </TableCell>

                <TableCell sortDirection={orderBy === "valor" ? order : false}>
                  <TableSortLabel
                    active={orderBy === "valor"}
                    direction={orderBy === "valor" ? order : "asc"}
                    onClick={() => handleSort("valor")}
                  >
                    Valor
                  </TableSortLabel>
                </TableCell>

                <TableCell>{/* Ícones */}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((menu) => (
                <TableRow key={menu.id}>
                  <TableCell>{menu.descricao}</TableCell>
                  <TableCell>{menu.grupo}</TableCell>
                  <TableCell>{pegarBaseUrl(menu.valor)}</TableCell>
                  <TableCell>
                    <Box
                      sx={{ display: "flex", gap: 1, justifyContent: "end" }}
                    >
                      <IconButton
                        aria-label="editar"
                        onClick={(event) => handleEditar(event, menu)}
                      >
                        <EditIcon style={{ color: "#1a3865" }} />
                      </IconButton>
                      <IconButton
                        aria-label="deletar"
                        onClick={(event) => handleClickOpenExcluir(event, menu)}
                      >
                        <DeleteIcon style={{ color: "#f4793c" }} />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={menu.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={sessao.rowsPerPage || 10}
          labelRowsPerPage="Linhas por página"
          rowsPerPageOptions={[5, 10, 25]}
          onRowsPerPageChange={handleChangeRowsPerPage}
          justifyContent="bottom"
          sx={{
            "& .MuiTablePagination-toolbar": {
              alignItems: "center",
            },
            "& p": {
              marginBottom: 0, // Remove a margem inferior do <p>
            },
          }}
        />
      </Paper>
    </Box>
  );
};

MenuTabela.propTypes = {
  menu: PropTypes.array.isRequired,
  setMenu: PropTypes.func.isRequired,
};

export default MenuTabela;
